import React from "react";
import Proptypes from "prop-types";
import styled from "styled-components";
import { compose, space, position, layout, shadow } from "styled-system";
import { Sidebar as PRStyledSidebar } from "primereact/sidebar";
import { breakpoints } from "@utils/breakpoints";
import Div from "@components/Div";
import Logo from "@assets/logo.svg";
import MenuContent from "./MenuContent";

const { mobile, tabletLandscape } = breakpoints;

const breakpoint = {
  tablet: `(min-width: ${mobile}px) and (max-width: ${tabletLandscape}px)`,
};

const SideBar = styled(PRStyledSidebar)`
  ${compose(space, position, layout, shadow)};
  width: 190px !important;
  background-color: var(--primary);
  overflow: hidden;
  .p-sidebar-header {
    padding: var(--md-spacing);
    padding-left: var(--sm-spacing);
    .p-sidebar-icon {
      display: none;
      left: 206px;
      top: var(--md-spacing);
      position: fixed !important;
      border-radius: 0;
      background-color: var(--white);
      color: var(--text);
      border-radius: var(--border-radii-regular);
      span {
        font-size: var(--fs-micro);
        font-weight: var(--black-weight);
      }
    }
    .p-sidebar-close:enabled:hover,
    .p-sidebar-icon:enabled:hover {
      background-color: var(--white) !important;
    }
    .p-sidebar-close:focus,
    .p-sidebar-icon:focus {
      box-shadow: none !important;
    }
  }
  .p-sidebar-content {
    padding: 0px;
    overflow: inherit;
    height: inherit;
  }
  @media ${breakpoint.tablet} {
    display: block;
    .p-sidebar-header {
      .p-sidebar-icon {
        display: flex !important;
      }
    }
  }
`;

const Sidemenu = ({ config = {}, display }) => {
  const {
    onClose = () => {},
    visibility = false,
    navItems: { navMenuItems = [], navBottomMenuItems = [] } = {},
  } = config;

  const mobileHeader = (
    <Div
      height="auto !important"
      width={1}
      pb="var(--xl-spacing)"
      pt="var(--regular-spacing)"
    >
      <img src={Logo} alt="image" />
    </Div>
  );

  return (
    <SideBar
      visible={visibility}
      boxShadow="none"
      fullScreen="true"
      showCloseIcon
      icons={mobileHeader}
      breakpoint={breakpoint}
      onHide={onClose}
      {...config}
      display={display}
    >
      <Div
        display="flex"
        justifyContent="space-between"
        flexDirection="column"
        height={["90%", "90%", "100%"]}
      >
        <MenuContent navItems={navMenuItems} />
        <MenuContent navItems={navBottomMenuItems} />
      </Div>
    </SideBar>
  );
};

Sidemenu.propTypes = {
  config: Proptypes.object,
  restProps: Proptypes.object,
  display: Proptypes.array,
};

export default Sidemenu;
